// H5 mobile debug console switch.
// Demo/debug: keep this value true, then real devices will show a vConsole button.
// Production: change to false, or comment out initVConsole() in src/index.js.
const ENABLE_H5_MOBILE_CONSOLE = true;

export const initVConsole = () => {
  if (!ENABLE_H5_MOBILE_CONSOLE) return;

  import("vconsole")
    .then(({ default: VConsole }) => {
      if (window.__H5_VCONSOLE__) return;

      // window.__H5_VCONSOLE__ = new VConsole({
      //   theme: "light",
      //   maxLogNumber: 1000,
      // });

      console.log("[vConsole] H5 mobile debug console enabled.");
    })
    .catch((err) => {
      console.error("Failed to load vconsole:", err);
    });
};
